import { render, staticRenderFns } from "./ProductTypeList.vue?vue&type=template&id=d60e2d0e&scoped=true"
import script from "./ProductTypeList.vue?vue&type=script&lang=js"
export * from "./ProductTypeList.vue?vue&type=script&lang=js"
import style0 from "./ProductTypeList.vue?vue&type=style&index=0&id=d60e2d0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60e2d0e",
  null
  
)

export default component.exports